import VueRouter from 'vue-router';
import Contract from './views/contracts/ContractView.vue';
import Contracts from './views/ContractsView.vue';
import RadarContract from './views/RadarContractView.vue';
import RadarContracts from './views/RadarContractsView.vue';
import BillingView from './views/BillingView.vue';
import ForecastView from './views/forecastpreset/ForecastView.vue';
import Login from './components/Auth/Login.vue'
import DomainsMap from './views/DomainsMapView.vue';
import ParametersView from './views/ParametersView.vue';
import ReanalysView from './views/ReanalysView.vue';
import ReanalysResultView from './views/ReanalysResultView.vue';
import ReanalysPresetView from './views/ReanalysPresetView.vue';
import ForecastResultView from './views/ForecastResultView.vue';
import ManagedPresetsView from './views/ManagedPresetsView.vue';
import ManagedOrderPresetsView from './views/ManagedOrderPresetsView.vue';
import PresetDetailsView from './views/presets/PresetDetailsView.vue';
import UsersView from './views/UsersView.vue';
import ApiServices from './views/ApiServices.vue';
import Presets from './views/PresetsView.vue';
import OrderPresets from './views/OrderPresetsView.vue';
import AddPreset from './views/AddPreset.vue';
import HomeView from './views/HomeView.vue';
import RadarView from './views/radar/RadarView.vue';
import UserRadarView from './views/radar/UserRadarView.vue';
import BillingUserView from './views/BillingUserView.vue';
import ForecastLongView from './views/forecastlong/ForecastLongView.vue';
import ForecastLongPresetView from './views/forecastlong/ForecastLongPresetView.vue';
import ForecastPoint from './views/forecastpoint/ForecastPointView.vue';
import ForecastPointsView from './views/forecastpoint/ForecastPointsView.vue';

import GeoMapView from './views/geomap/GeoMapView.vue';
import GeoMapContractsView from './views/geomap/GeoMapContractsView.vue';
import GeoMapContractView from './views/geomap/GeoMapContractView.vue';
import GeoMapBillingView from './views/geomap/GeoMapBillingView.vue';

import SynopContractsView from './views/synopcontracts/SynopContractsView.vue';
import SynopContractView from './views/synopcontracts/SynopContractView.vue';

import SynopView from './views/synop/SynopView.vue';

import VersionView from './views/VersionView.vue';


const router = new VueRouter({
  routes: [
    {
      path: '',
      component: HomeView,
      name: 'HOME'
    },
    {
      path: '/domains/map',
      component: DomainsMap
    },
    {
      path: '/contract/:contractId/:userId',
      props: true,
      name: 'CONTRACT',
      component: Contract
    },
    {
      path: '/radarcontract/:contractId/:userId',
      props: true,
      name: 'RADAR_CONTRACT',
      component: RadarContract
    },
    {
      path: '/contract/add',
      component: Contract
    },
    {
      path: '/radar/contract/add',
      component: RadarContract
    },
    {
      path: '/users',
      component: UsersView
    },
    {
      path: '/contracts',
      component: Contracts
    },
    {
      path: '/radar/contracts',
      name: 'RADAR_CONTRACTS',
      component: RadarContracts
    },
    {
      path: '/version',
      name: 'VERSION',
      component: VersionView
    },
    {
      path: '/radar/contracts/:userId',
      props: true,
      name: 'RADAR_CONTRACTS_USER',
      component: RadarContracts
    },
    {
      path: '/billing',
      component: BillingView
    },
    {
      path: '/forecast/preset',
      component: ForecastView
    },
    {
      path: '/forecast/point',
      component: ForecastPoint
    },
    {
      path: '/forecast/points',
      component: ForecastPointsView
    },
    {
      path: '/presets/list',
      component: Presets,
      name: 'USER_PRESETS'
    },
    {
      path: '/login',
      name: 'LOGIN',
      component: Login
    },
    {
      path: '/services',
      name: 'API_SERVICES',
      component: ApiServices
    },
    {
      path: '/domains/map',
      component: DomainsMap,
      name: 'DOMAINS_MAP'
    },
    {
      path: '/parameters',
      component: ParametersView
    },
    {
      path: '/reanalys',
      component: ReanalysView
    },
    {
      path: '/reanalys/result/:userId/:dateStart/:dateEnd/:latitude/:longitude',
      props: true,
      name: 'REANALYS_RESULT',
      component: ReanalysResultView
    },
    {
      path: '/reanalyspreset',
      name: 'REANALYS_PRESET',
      component: ReanalysPresetView
    },
    {
      path: '/forecast/result/:forecastParams',
      name: 'FORECAST_RESULT',
      props: true,
      component: ForecastResultView
    },
    {
      path: '/managedpresets/details/:userId/:presetId',
      name: 'PRESET_DETAILS',
      props: true,
      component: PresetDetailsView
    },
    {
      path: '/managedpresets/list',
      name: 'PRESETS_LIST',
      props: true,
      component: ManagedPresetsView
    },
    {
      path: '/managedorderpresets/list',
      name: 'MANAGED_ORDER_PRESETS',
      props: true,
      component: ManagedOrderPresetsView
    },
    {
      path: '/orderpresets/list',
      name: 'ORDER_PRESETS_LIST',
      props: true,
      component: OrderPresets
    },
    {
      path: '/orderpresets/add',
      name: 'ADD_PRESET',
      component: AddPreset
    },
    {
      path: '/radars/viewer',
      name: 'RADAR',
      component: RadarView
    },
    {
      path: '/radars/user',
      name: 'USER_RADAR',
      component: UserRadarView
    },
    {
      path: '/billing/user',
      name: 'USER_BILLING',
      component: BillingUserView
    },
    {
      path: '/forecast/long',
      name: 'FORECAST_LONG',
      component: ForecastLongView
    },
    {
      path: '/forecast/long/preset',
      name: 'FORECAST_LONG_PRESET',
      component: ForecastLongPresetView
    },
    {
      path: '/geomap/viewer',
      name: 'GEO_MAP',
      component: GeoMapView
    },
    {
      path: '/geomap/contracts',
      name: 'GEO_MAP_CONTRACTS',
      component: GeoMapContractsView
    },
    {
      path: '/geomap/contracts/:userId',
      props: true,
      name: 'GEO_MAP_CONTRACTS_USER',
      component: GeoMapContractsView
    },
    {
      path: '/geomap/contract/:contractId/userId/:userId',
      props: true,
      name: 'GEOMAP_CONTRACT',
      component: GeoMapContractView
    },
    {
      path: '/geomap/contract/add',
      name: 'GEOMAP_CONTRACT_ADD',
      component: GeoMapContractView
    },
    {
      path: '/geomap/statistics',
      name: 'GEOMAP_STATISCTICS',
      component: GeoMapBillingView
    },


    {
      path: '/synop/contracts',
      name: 'SYNOP_CONTRACTS',
      component: SynopContractsView
    },
    {
      path: '/synop/contracts/:userId',
      props: true,
      name: 'SYNOP_CONTRACTS_USER',
      component: SynopContractsView
    },
    {
      path: '/synop/contract/:contractId/userId/:userId',
      props: true,
      name: 'SYNOP_CONTRACT',
      component: SynopContractView
    },
    {
      path: '/synop/contract/add',
      name: 'SYNOP_CONTRACT_ADD',
      component: SynopContractView
    },
    {
      path: '/synop',
      name: 'SYNOP',
      component: SynopView
    },
  ],
  mode: 'history'
});

export default router;